export default "__VITE_ASSET__226f147a__"